import { compose } from 'redux';
import { connect } from 'react-redux';
import selectors from '../../../../rootSelectors';
import RCTFluencyPracticeView from './RCTFluencyPracticeView';
import { stopAudio } from '../../../../common/audio/audioActions';
import {
    hideQuestion, showSegment, hideSegment, fetchRctFluCompContent,
} from '../../../rctActions';
import {
    unmountScreen, blockScreen, unblockScreen, enableDownButton, disableDownButton,
}
    from '../../../../common/screen/screenActions';
import { PRACTICE } from '../../../../constants/assessmentItemType';
import {
    narrateActiveScript, showNextElementOnDownButtonClick, showNextSegment,
    onNextSegmentClick, handleNextClick,
} from './RCTFluencyPracticeActions';
import { selectPossibleResponse, resetQuestionsAndTimeTrackingState }
    from '../../../../common/questions/questionsActions';
import RCT_AUDIO_INSTRUCTIONS from '../../../rctConstants';
import AvatarView from '../../../../common/avatar/avatarView';
import withAvatar from '../../../../common/avatar/withAvatar';

const FLUENCY_AUDIO = RCT_AUDIO_INSTRUCTIONS.FLUENCY;

const mapStateToProps = (state) => ({
    isScreenBlocked: selectors.getIsScreenBlocked(state),
    isNextButtonActive: selectors.getIsNextButtonActive(state),
    isDownButtonEnabled: selectors.getIsDownButtonEnabled(state),
    isDataFetched: selectors.getIsRCTFluencyDataFetched(state),
    segments: selectors.getSegments(state, PRACTICE),
    question: selectors.getCurrentQuestion(state, PRACTICE),
    passageTitle: selectors.getPassageTitle(state, PRACTICE),
    activeSegmentIndex: selectors.getActiveSegmentIndex(state),
    isQuestionVisible: selectors.getIsQuestionVisible(state),
    isSegmentVisible: selectors.getIsSegmentVisible(state),
    selectedResponse: selectors.getSelectedIndex(state),
    isGreyedOut: selectors.getIsScreenGreyedOut(state),
});

const mapDispatchToProps = (dispatch) => ({
    fetchContent: () => {
        dispatch(fetchRctFluCompContent());
    },
    initPractice: () => {
        dispatch(blockScreen());
        dispatch(showSegment(2));
        dispatch(enableDownButton());
        dispatch(narrateActiveScript())
            .then(() => {
                dispatch(unblockScreen());
            });
    },
    onDownButtonClick: () => {
        dispatch(disableDownButton());
        dispatch(hideSegment());
        dispatch(showNextElementOnDownButtonClick());
    },
    onResponseSelected: (index) => {
        dispatch(blockScreen());
        dispatch(selectPossibleResponse(index));
        dispatch(hideQuestion());
    },
    onPopupQuestionHide: () => {
        dispatch(resetQuestionsAndTimeTrackingState());
        dispatch(showNextSegment());
        dispatch(unblockScreen());
    },
    onSegmentShow: () => {
        dispatch(onNextSegmentClick());
    },
    onNextClick: () => {
        dispatch(handleNextClick());
    },
    cleanup: () => {
        dispatch(stopAudio());
        dispatch(resetQuestionsAndTimeTrackingState());
        dispatch(unmountScreen());
    },
});

const avatarMapStateToProps = () => ({
    position: AvatarView.Position.MIDDLE_LEFT,
    instructions: FLUENCY_AUDIO.modelInstructionReplay,
});

const RCTFluencyPracticeContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(RCTFluencyPracticeView);

export default RCTFluencyPracticeContainer;
